export default {
  borderRadius: 10,
}
